import { Component, Input, Output, EventEmitter } from '@angular/core';
import {  Person } from 'src/app/interfaces/dss';
import { FunctionsService } from 'src/app/services/functions/functions.service';


@Component({
  selector: 'siselse-card',  
  templateUrl: './card.component.html',
})
export class SiselseCardComponent {
  @Input() card: Person;
  @Output() toggleCard = new EventEmitter<{ card: Person; event: CustomEvent<any>; }>(); // Change the type here
  constructor(
    public funcServ: FunctionsService

  ) { }

  // Cuando el ionChange se dispara, llama a este método
  onIonChange(card: Person, event: CustomEvent) {
    this.toggleCard.emit({card, event});
  }
  convertHexToDecimalIfHex(hexString) {
    const hexRegex = /^[0-9A-Fa-f]+$/;
    
    if (hexRegex.test(hexString)) {
      return parseInt(hexString, 16);
    } else {
      return hexString;
    }
  }

  transformSISString(sisString: string) {
    const sisPrefix = 'SIS';
  
    if (sisString.startsWith(sisPrefix)) {
      let transformedString = sisString.replace(sisPrefix, 'SIPASS');
      transformedString = transformedString.replace(/z/g, '-');
      return transformedString;
    } else {
      return sisString;
    }
  }
}